// extracted by mini-css-extract-plugin
export default {"container":"styles_container__1zgWx","right":"styles_right__+6sey","title":"styles_title__0myJV","description":"styles_description__u9JxQ","button":"styles_button__hqMal"};